import React, { useState } from "react";
import { Amplify } from "aws-amplify";
import { post } from "aws-amplify/api";
import amplifyconfig from '../amplifyconfiguration.json';
import Modal from "./Modal";

Amplify.configure(amplifyconfig);

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, messag }, setState] = useState(initialState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [txt, setTxt] = useState("");
  const [message, setMessage] = useState("");

  function abrirModal() {
    setIsModalOpen(true);
}

  const handleChange = (e) => {
      const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(name, email, messag);
    const response = await postData();
    console.log(response);
 //   clearState();
  };

const postData = async () => {
  setTxt("ando");
  setMessage("enviando");
  abrirModal();
  const apiName = "PriDispContactForm";
  const path = '/items';
  const payload = { username: name, usermail: email, message: messag };
    try {
    const data = post({
      apiName: apiName,
      path: path,
      options: {
        body: payload
      }
    })
    const { body } = await data.response;
    const response = await body.json();
    if (response.aCliente.MessageId) {
      setTxt("ok");
      setMessage("okctco");
      clearState();
      return ("SUCCESS");
    }
    console.log(response); // Cambiar por mensaje de enviado correcto
    } catch (err) {
        setTxt("error");
        setMessage("errorctco");
        console.log(err); //agregar que hubo error
        return ("FAILED");
        }
    
}

  return (
    <div>
        <Modal isOpen={isModalOpen} msg={message} txt={txt} closeModal={() => setIsModalOpen(false)} />
      <div id="contact">
        <div className="container">
        <div className="section-title">
                <h2>Contáctenos</h2>
                <p>
                  Complete el siguiente formulario para ponerse en contacto con nosotros,
                  le responderemos a la brevedad.
                </p>
              </div>
        <div className="col-md-3 contact-info">
            <div className="contact-item">
              <h3>Información de contacto</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Ubicación
                </span>
                {props.data ? props.data.address : "cargando"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Teléfono
                </span>{" "}
                {props.data ? props.data.phone : "cargando"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Correo electrónico
                </span>{" "}
                {props.data ? props.data.email : "cargando"}
              </p>
            </div>
          </div>
          <div className="col-md-8">
            <div className="row">
              <form name="sentMessage" validate="true" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="btn-custom"
                        placeholder="Nombre"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="btn-custom"
                        placeholder="Correo electrónico"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="messag"
                    id="messag"
                    className="btn-custom"
                    rows="4"
                    placeholder="Mensaje"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom1 btn-lg">
                  Enviar mensaje
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2023 Issaaf Kattan React Land Page Template. Design by{" "}
            <a href="http://www.templatewire.com" rel="nofollow">
              TemplateWire
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};


/*
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
*/